import { call, put, takeLatest } from 'redux-saga/effects';
import api, * as urls from '../api';
import {
  generateCollateralHashId,
  GENERATE_COLLATERAL_HASH_ID,
  generateHashId,
} from '../reducers/authReducer';
import { createSaga } from '../utils/createSaga';

function* generateHashIdSaga({ payload }) {
  try {
    const hashId = yield call(
      api.post,
      urls.GENERATE_HASH_ID_API_ENDPOINT,
      payload,
    );
    yield put(generateHashId.success(hashId));
  } catch (e) {
    yield put(generateHashId.failure(e.response));
  }
}

export default function* watchFeeRebates() {
  yield takeLatest(generateHashId.TRIGGER, generateHashIdSaga);
  yield takeLatest(
    generateCollateralHashId.TRIGGER,
    createSaga(generateCollateralHashId, GENERATE_COLLATERAL_HASH_ID),
  );
}
